<template>
  <div class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 min-w-card">
    <div
      class="card card-bio-content card--interactive text-center"
      @click="visitProfile"
    >
      <div @click.stop>
        <DotPopper
          v-if="canBeEditedByGroupAdmin"
          :options="{ placement: 'bottom-end' }"
        >
          <div
            slot="content"
            class="flex flex-col"
          >
            <a
              :href="editLink"
              v-text="'Edit'"
            />
          </div>
        </DotPopper>
      </div>
      <h6
        class="text-blue uppercase -mt-2 mb-4"
        v-html="membershipStatus"
      />
      <img
        :src="avatarUrl"
        alt=""
        class="rounded-full w-16"
      >
      <h4
        class="my-0"
        v-text="fullName"
      />
    </div>
  </div>
</template>

<script type="text/babel">
import DotPopper from 'Base/Resources/assets/js/components/DotPopper'

export default {
  name: 'MembershipCard',
  components: {
    DotPopper,
  },
  props: {
    membership: {
      type: Object,
      required: true,
    },
  },
  computed: {
    membershipStatus() {
      return this.membership.attributes.deactivated
        ? 'Deactivated'
        : _.upperFirst(this.membership.attributes.status)
    },
    editLink() {
      return this.$urlGenerator.active(`members/${this.membership.uuid}/edit`)
    },
    fullName() {
      return this.membership.attributes.full_name_concatenated
    },
    avatarUrl() {
      return this.membership.attributes.small_avatar_url
    },
    canBeEditedByGroupAdmin(){
      return this.membership.attributes.can_be_edited_by_group_admin
    },
  },
  methods: {
    visitProfile() {
      window.location = this.$urlGenerator.active(`members/${this.membership.uuid}`)
    },
  },
}
</script>
